import { TEST_IDS } from '@va/constants';
import { SearchIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { CloseIconWithBorder } from '@va/svg-visa-icons';
import classNames from 'classnames';
import type { ChangeEvent } from 'react';
import './style.scss';

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
};

/** @deprecated TODO Update or delete*/
export const SearchInput = ({ value, onChange, id, className = '', placeholder, disabled }: SearchInputProps) => {
  const translate = useTranslate();

  const onInputChanged = (value: string) => {
    onChange(value);
  };

  return (
    <div
      className={classNames(
        className,
        `search-input flex p-6px w-full h-[3rem] rounded-xl cursor-default bg-white-snow hover:bg-gray-concrete active:bg-gray-concrete`,
        { 'cursor-not-allowed': disabled },
      )}
      id={id}
    >
      <SearchIcon className='flex-shrink-0' color='#696969' />
      <input
        data-testid={TEST_IDS.generic.inputs.search}
        className='bg-transparent text-primary text-sm'
        type='text'
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onInputChanged(e.target.value)}
        placeholder={placeholder ? placeholder : `${translate('filter.search')}...`}
        disabled={disabled}
      />
      <CloseIconWithBorder
        className={classNames({ hidden: !value, 'cursor-pointer': value })}
        color={'#C3C3C3'}
        radius={10}
        onClick={() => {
          onInputChanged('');
        }}
      />
    </div>
  );
};
